import { commonUtils } from '@/helpers/commonUtils'
import PdfPage, { PageHeader } from '../PdfPage/PdfPage'
import styles from './PdfPage6.module.less'
import { useScoreChartData } from '@/pages/ProjectDetailPage/components/VideoAnalysis/VideoAnalysis'
import VideoScoreBarChart from '@/pages/ProjectDetailPage/components/VideoAnalysis/VideoScoreBarChart/VideoScoreBarChart'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage6({ project, onRendered, no }: Props) {
  const { firstScoreChart, secondScoreChart } = useScoreChartData(project)
  const mode = project.globalMetrics.overall.score >= project.globalMetrics.overall.meanScore ? 'high' : 'low'
  const { t } = useTranslation()

  useEffect(() => {
    onRendered(1)
  }, [])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-6/PDF-bg.jpg')} no={no}>
      <div className={styles.pdfPage6}>
        <PageHeader
          project={project}
          text={'02.' + t('dashboard.projectDetailPage.primaryAnalysis')}
        />
        <div className={styles.content}>
          <span className={styles.contentTitle}>
            {t('dashboard.projectDetailPage.videoView.indexAnalysis')}
            {/* <span className={styles.highlight}>Index</span> Analysis */}
          </span>
          <div className={styles.score}>
            <img
              className={styles.scoreBg}
              src={
                mode === 'high'
                  ? commonUtils.getImagePath('PDFDownload/pdf-page-6/score-bg.png')
                  : commonUtils.getImagePath('PDFDownload/pdf-page-6/score-bg-1.png')
              }
              alt=''
            />
            <div className={styles.scoreValue} style={{ color: mode === 'high' ? '#6D54FA' : '#616B7E' }}>{project.globalMetrics.overall.score}</div>
            <div className={styles.scoreTitle} style={{ color: mode === 'high' ? '#7F69EA' : '#868E9D' }}>
              {t('dashboard.projectDetailPage.videoView.adVideoScore')}
            </div>
            <div className={styles.scoreDesc}>
              {t('dashboard.projectDetailPage.videoView.norm')}:{' '}
              {project.globalMetrics.overall.meanScore}
            </div>
          </div>
        </div>
        <div className={styles.chart}>
          <VideoScoreBarChart
            chartGap={130}
            overallFlex={1}
            periodFlex={1.8}
            defaultHeight={530}
            barWidth={68}
            barLabelSize={18}
            barTextSize={32}
            barTextLineHeight='51px'
            overallDatas={firstScoreChart.datas}
            periodDatas={secondScoreChart.datas}
          />
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPage6
